export const isFn = (functionToCheck: unknown): boolean =>
  functionToCheck !== undefined && {}.toString.call(functionToCheck) === '[object Function]'
